// BE 상한과 같다 — 양끝 포함 31일. 넘기면 BE 가 400 을 준다 (LOGISPRD-15468)
export const MAX_PERIOD_DAYS_ON_INTERFACE_HISTORY = 31

// HS01·HS03 — 기간을 비우면 BE 가 키 이름(evtDateFrom) 그대로 400 을 주므로 먼저 막는다
export const EMPTY_EVT_DATE_MESSAGE = '사용일자를 입력해 주세요.'
